package com.macrofocus.eflux.network.risk

import com.macrofocus.eflux.network.line.Line
import org.locationtech.jts.geom.Geometry
import org.locationtech.jts.geom.MultiPolygon
import org.locationtech.jts.geom.Polygon
import org.locationtech.jts.geom.util.GeometryCombiner

class RiskComponent(val lines: Set<Line>, private val geometries: List<Geometry>, ) {
    val polygon: Iterable<RiskComponentPolygon> = run {
        val componentList: List<RiskComponentPolygon>
        val unionGeometry: Geometry? = GeometryCombiner.Companion.combine(geometries)?.union()
        //            println(unionGeometry)
        if (unionGeometry is MultiPolygon) {
            componentList = List(unionGeometry.numGeometries) { i ->
                RiskComponentPolygon(this, unionGeometry.getGeometryN(i) as Polygon)
            }
        } else if (unionGeometry is Polygon) {
//            val g: Array<Array<DoubleArray>> = polygonToDeckGL(unionGeometry)
            componentList = listOf(RiskComponentPolygon(this, unionGeometry))
        } else {
            componentList = emptyList()
        }
        componentList
    }
}